import React, { useContext, useRef } from "react"
import { SortableContainer } from "react-sortable-hoc"
import { ConfigureWindowModalContext } from "./ConfigureWindowModal"
import { ModalityGraphGroupConfig, ModalityGraphGroupConfigJSON } from "../../../../Pages/Data/Visualize/DataReview/Types/ModalityGraphGroup"
import { useSetRecoilState, useRecoilValue } from "recoil"
import { editedLayoutGroupAtom, selectedLayoutIdAtom } from "../../../../Pages/Data/Visualize/DataReview/Atoms/Layout"
import { GraphToggleButton } from "./GraphToggleButton"
import { MobergFontFamily, MobergRow, MobergText } from "../../../../Moberg"
import { ModalityGraphConfig } from "../../../../Pages/Data/Visualize/DataReview/Types/Graph"

type SortEndEvent = {
    oldIndex: number
    newIndex: number
}

export const SortableGraphs = () => {
    const containerRef = useRef<HTMLDivElement | null>(null)
    const { currentWindow } = useContext(ConfigureWindowModalContext)
    const setEditedLayoutGroup = useSetRecoilState(editedLayoutGroupAtom)
    const selectedLayoutId = useRecoilValue(selectedLayoutIdAtom)
    const graphs = (currentWindow?.props as ModalityGraphGroupConfig | undefined)?.graphs ?? []

    const onSortEnd = ({ oldIndex, newIndex }: SortEndEvent) => {
        const newGraphs = [...graphs]
        const [element] = newGraphs.splice(oldIndex, 1)
        newGraphs.splice(newIndex, 0, element)

        setEditedLayoutGroup(previous => {
            if (!previous) {
                return previous
            }

            const copy = structuredClone(previous)
            const layout = copy.layouts.find(layout => layout.id === selectedLayoutId)
            const area = layout?.areas.find(area => area.area === currentWindow?.area)
            
            if (area && area.props) {
                (area.props as ModalityGraphGroupConfigJSON).graphs = newGraphs
            }

            return copy
        })
    }

    return (
        <div ref={containerRef}>
            <SortableGraphList
                useDragHandle={true}
                graphs={graphs}
                onSortEnd={onSortEnd}
                helperContainer={containerRef.current ?? undefined}
            />
        </div>

    )
}

const SortableGraphList = SortableContainer(({ graphs }: { graphs: ModalityGraphConfig[] }) => {
    const { currentGraph, setSelectedGraphId, removeGraph } = useContext(ConfigureWindowModalContext)
    const anyGraphs = (graphs ?? []).length > 0

    return (
        <div>
            {anyGraphs
                ? graphs.map((graph, index) => (
                    <GraphToggleButton
                        key={graph.id}
                        index={index}
                        graph={graph}
                        isActive={graph.id === currentGraph?.id}
                        removeGraph={removeGraph}
                        setSelectedGraphId={setSelectedGraphId}
                    />)
                )
                : (
                    <MobergRow style={{ padding: "20px 90px" }}>
                        <MobergText style={{ fontSize: "26px", fontFamily: MobergFontFamily.REGULAR }}>
                            No graphs
                        </MobergText>
                    </MobergRow>
                )
            }
        </div>
    )
})